export const resolveRequestProgress = (status) => {
    switch (status) {
        case 'pen':
            return 0;
        case 'pro':
            return 2;
        case 'app':
            return 4;
        default:
            return null;
    }
}
